import { Injectable } from '@angular/core';
import {
  DIALOG_TYPE as errorDialog,
  IErrorDialogData,
} from './error-dialog.component';

@Injectable()
export class ErrorDialogBuilder {
  constructor() {}

  buildGlobalErrorDialog(
    errorTitle: string,
    errorMessage: string,
    okText: string = null
  ): any {
    return {
      type: errorDialog,
      data: this.buildDialogData(errorTitle, errorMessage, okText),
    };
  }

  buildDialogData(
    errorTitle: string,
    errorMessage: string,
    okText: string = null
  ): IErrorDialogData {
    return {
      okText: okText,
      errorTitle: errorTitle,
      errorMessage: errorMessage,
    };
  }
}
